module.exports = __webpack_public_path__ + "static/media/Fulgur.949b3d04.svg";